import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { menuItems } from './SidebarMenuItems';
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "@/components/ui/sidebar";

interface SidebarNavigationProps {
  isMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  onSignOut: () => void;
}

export const SidebarNavigation: FC<SidebarNavigationProps> = ({ 
  isMobile, 
  setOpenMobile,
  onSignOut
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <SidebarMenu className="space-y-3 md:space-y-2">
      {menuItems.map((item) => (
        <SidebarMenuItem key={item.title} className="py-1 md:py-0.5">
          <SidebarMenuButton
            onClick={() => handleNavigation(item.path)}
            isActive={location.pathname === item.path}
            tooltip={item.title}
            className="group relative flex items-center gap-4 rounded-xl p-4 text-base font-semibold transition-all duration-300 ease-in-out hover:bg-primary/10 data-[active=true]:bg-primary data-[active=true]:text-white"
          >
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 shadow-inner transition-transform group-hover:scale-110 group-hover:shadow-lg">
              <item.icon className="h-6 w-6 transition-all duration-300 ease-in-out group-hover:scale-110" />
            </div>
            <span className="text-lg transition-all duration-300 ease-in-out group-hover:translate-x-1">
              {item.title}
            </span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}

      <SidebarMenuItem className="py-1 md:py-0.5">
        <SidebarMenuButton
          onClick={() => {
            onSignOut();
            if (isMobile) {
              setOpenMobile(false);
            }
          }}
          tooltip="Cerrar Sesión"
          className="group relative flex items-center gap-4 rounded-xl p-4 text-base font-semibold transition-all duration-300 ease-in-out hover:bg-gray-100 text-gray-600 hover:text-gray-700"
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-red-50 shadow-inner transition-transform group-hover:scale-110 group-hover:shadow-lg">
            <LogOut className="h-6 w-6 transition-all duration-300 ease-in-out group-hover:scale-110" />
          </div>
          <span className="text-lg transition-all duration-300 ease-in-out group-hover:translate-x-1">
            Cerrar Sesión
          </span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};